module.exports = __webpack_public_path__ + "static/extras_bg.2b0740e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/extras_bg.jpg
// module id = 3110
// module chunks = 174994552580003